import { GroupsPanelCombinedProps } from './types';

const usePresenter = (props: GroupsPanelCombinedProps): GroupsPanelCombinedProps => {
  return props;
};

export default usePresenter;
